import { API_BASE, refreshSession } from "@/lib/api";

const UNAVAILABLE = "Your concierge is momentarily unavailable. Please try again.";

function post(content) {
  return fetch(`${API_BASE}/concierge/messages`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ content }),
  });
}

// Streams the concierge reply over SSE; resolves with the saved user + assistant messages.
export async function streamChat(content, onDelta) {
  let res = await post(content);
  if (res.status === 401) {
    await refreshSession();
    res = await post(content);
  }
  if (!res.ok || !res.body) throw new Error(UNAVAILABLE);

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  const result = {};
  let buffer = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    let idx;
    while ((idx = buffer.indexOf("\n\n")) >= 0) {
      const line = buffer.slice(0, idx).split("\n").find((l) => l.startsWith("data: "));
      buffer = buffer.slice(idx + 2);
      if (!line) continue;
      const ev = JSON.parse(line.slice(6));
      if (ev.type === "user") result.user = ev.message;
      else if (ev.type === "delta") onDelta(ev.content);
      else if (ev.type === "done") result.reply = ev.message;
      else if (ev.type === "error") throw new Error(ev.detail || UNAVAILABLE);
    }
  }
  if (!result.user || !result.reply) throw new Error(UNAVAILABLE);
  return result;
}
